import { type HumanTaskBlockFormFieldsProps } from './types';
import { BlockValueTemplateFieldArea } from '../../../../ConfigFields/CodeMirror/FlowTemplate';

export function HumanTaskMarkdownBlockFormFields(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <BlockValueTemplateFieldArea
      label="Content"
      fieldName={`${fieldNamePrefix}.content`}
      helperText="Use markdown to apply text formatting to your instructions"
    />
  );
}
